export async function fetchReplies(id) {
  try {
    let response = await fetch(`/api/posts/${id}/replies`);
    let replies = await response.json();
    if (response.ok) {
      return replies;
    }
    if (replies.satusCode === 401 || replies.satusCode === 403) {
      console.error('Replies not found');
    }
  } catch (err) {
    console.error(err);
  }
}

/**
 * Get user unread posts
 * @param {Object} params - Request parameters
 * @param {string} params.authorUserId - User ID
 * @param {number} [params.offset=0] - Pagination offset
 * @param {number} [params.limit=15] - Number of posts per page
 * @returns {Promise<Object>} - Response object with results
 */
export async function fetchUserUnreadPosts(params) {
  try {
    const query = {
      authorUserId: params.authorUserId,
      limit: params.limit || 15,
    };
    if (params.after) query.after = params.after;

    const queryParams = new URLSearchParams(query).toString();

    const response = await fetch(`/api/posts/unread?${queryParams}`, {
      headers: {
        'Cache-Control': 'no-cache',
      },
    });

    if (!response.ok) {
      console.error('Error fetching unread posts:', response.statusText);
      return { results: [] };
    }

    const data = await response.json();
    return data;
  } catch (error) {
    return { results: [] };
  }
}

/**
 * Bulk mark posts as read by user
 * @param {string} authorUserId - MongoDB ObjectId of the author
 * @param {Array<string>} postIds - Array of post IDs to mark as read
 * @returns {Promise<Response>} - API response
 */
export async function markPostsAsRead(authorUserId, postIds) {
  try {
    const response = await fetch('/api/posts/mark-as-read', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ authorUserId, postIds }),
    });
    if (response.status === 204) {
      return true;
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error marking posts as read:', error);
    return null;
  }
}
